module.exports = __webpack_public_path__ + "img/W-C11.e2f36414.jpg";